var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.25 7C0.25 3.27179 3.27179 0.25 7 0.25C10.7282 0.25 13.75 3.27179 13.75 7C13.75 8.59388 13.1977 10.0586 12.274 11.2134L15.5303 14.4697C15.8232 14.7626 15.8232 15.2374 15.5303 15.5303C15.2374 15.8232 14.7626 15.8232 14.4697 15.5303L11.2134 12.274C10.0586 13.1977 8.59388 13.75 7 13.75C3.27179 13.75 0.25 10.7282 0.25 7ZM1.75 7C1.75 4.10021 4.10021 1.75 7 1.75C9.89979 1.75 12.25 4.10021 12.25 7C12.25 9.89979 9.89979 12.25 7 12.25C4.10021 12.25 1.75 9.89979 1.75 7Z","fill":"#181818"}));
}

Search.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Search;

Search.default = Search;
